import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';

export default defineNuxtPlugin((nuxtApp) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 минут
        gcTime: 1000 * 60 * 10, // 10 минут (ранее cacheTime)
      },
    },
  });

  nuxtApp.vueApp.use(VueQueryPlugin, { queryClient });
});
